export enum responseTypes {
  OCTET_STREAM = 'application/octet-stream',
  PDF = 'application/pdf'
}
